import TableBase from "../TableBase"
import api from '../../apis/api';
import { defaultOptions } from "../../GlobalStyles/MUIDefaultSettings";
import { Link } from 'react-router-dom';
import { Button, Tab, Menu, Label } from "semantic-ui-react";
import { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import { epochToStringNoT } from "../EpochToString";
import { useAlertsStore } from "../../store/AlertsStore";
import { useOrgStore } from "../../store/OrgStore";
import Alerts from "./Alerts";
import { severity_color } from "./IconMatrix";

const AssignedTickets = ({ tickets, unassigned }) => {

    const userContext = useContext(UserContext)

    const { org } = useOrgStore()
    const { alerts } = useAlertsStore()
    let ticks = []
    let active_alerts = []
    
    let sites = userContext.userInfo.site_list.filter(s => s.owner === org).map(i => i.site)
    let siteIds = userContext.userInfo.site_list.filter(s => s.owner === org).map(i => i.id)

    function check_site(t){
        let bool = false
        t.sites.forEach(s => {
            if(sites.includes(s)){
                bool = true
            }
        })
        return bool
    }

    if(org){
        ticks = tickets.filter(check_site)
        active_alerts = alerts.filter(a => siteIds.includes(a.databaseId))
    } else {
        ticks = tickets
        active_alerts = alerts
    }


    const change_columns = [
        {name: "number", label: "Ticket #", options: {customBodyRender: (v) => <Button color="blue" as={Link} to={`/tickets/details/${v}`} target="_blank" size="mini">{v}</Button>}},
        {name: "subject", label: "Subject"},
        {name: "status", label: "Status"},
        {name: "startDate", label: "Start Date", options: {customBodyRender: (v) => epochToStringNoT(v)}}
    ]

    const columns = [
        {name: "number", label: "Ticket #", options: {customBodyRender: (v) => <Button color="blue" as={Link} to={`/tickets/details/${v}`} target="_blank"  size="mini">{v}</Button>}},
        {name: "severity", label: "Severity"},
        {name: "subject", label: "Subject"},
        {name: "status", label: "Status"},
    ]

    const unassigned_columns = [
        {name: "number", label: "Ticket #", options: {customBodyRender: (v) => <Button color="blue" as={Link} to={`/tickets/details/${v}`} target="_blank"  size="mini">{v}</Button>}},
        {name: "severity", label: "Severity"},
        {name: "type", label: "Type"},
        {name: "subject", label: "Subject"},
        {name: "status", label: "Status"},
    ]

    const incidents = ticks.filter(t => t.type === 'incident')
    const change = ticks.filter(t => t.type === 'change')
    const tca_rm = ticks.filter(t => t.type === 'tca_rm')
    const access = ticks.filter(t => t.type === 'access')

    const sevs = active_alerts.map(i => i.searchIndex.severity)
    const min_sev = Math.min(...sevs)

    return (
            <Tab panes={[
                // {menuItem: "Events", render: () => <Tab.Pane><OrgCalendar tickets={ticks.filter(i => (['access', 'tca_rm', 'change'].includes(i.type)))} /></Tab.Pane>},
                {menuItem: (<Menu.Item>Alerts <Label color={active_alerts.length > 0?severity_color[min_sev]:"blue"}>{active_alerts.length}</Label></Menu.Item>), render: () => <Tab.Pane><Alerts alerts={active_alerts} /></Tab.Pane>},
                {menuItem: (<Menu.Item>Incidents <Label color={incidents.length > 0 ? "red": "blue"}>{incidents.length}</Label></Menu.Item>), render: () => <Tab.Pane><TableBase data={incidents} columns={columns} options={defaultOptions} /></Tab.Pane>},
                {menuItem: (<Menu.Item>Change <Label color={change.length > 0 ? "red": "blue"}>{change.length}</Label></Menu.Item>), render: () => <Tab.Pane><TableBase data={change} columns={change_columns} options={defaultOptions} /></Tab.Pane>},
                {menuItem: (<Menu.Item>TCA/RM <Label color={tca_rm.length > 0 ? "red": "blue"}>{tca_rm.length}</Label></Menu.Item>), render: () => <Tab.Pane><TableBase data={tca_rm} columns={change_columns} options={defaultOptions} /></Tab.Pane>},
                {menuItem: (<Menu.Item>Access <Label color={access.length > 0 ? "red": "blue"}>{access.length}</Label></Menu.Item>), render: () => <Tab.Pane><TableBase data={access} columns={change_columns} options={defaultOptions} /></Tab.Pane>},
                {menuItem: (<Menu.Item>Unassigned <Label color={unassigned.length > 0 ? "red": "blue"}>{unassigned.length}</Label></Menu.Item>), render: () =>  <Tab.Pane><TableBase data={unassigned} columns={unassigned_columns} options={defaultOptions} /></Tab.Pane>},

            ]}
            />
    )

}

export default AssignedTickets